export default {
  prepr: {
    environments: {
      'f7e9030a-3120-4646-872b-d3f2917246c9': {
        baseUrl: 'https://beam.eo.nl',
        name: 'BEAM',
        publicationId: '6e12dcd1-c1f6-4762-8738-76c59a0d1b1f',
        slug: 'beam-eo',
      },
      '4476030f-5b63-4c5a-bb65-58585f8f408c': {
        baseUrl: 'https://nederlandzingt.eo.nl',
        name: 'Bijbel Open',
        publicationId: '84ffdfb2-dbfb-4fd6-b83e-f428e85d73e1',
        slug: 'bijbelopen-eo',
      },
      '46d45ec7-bd56-4f56-82be-f2f7b5505887': {
        baseUrl: 'https://blauwbloed.eo.nl',
        name: 'Blauw Bloed',
        publicationId: '4afdeff2-2983-4cf7-afe2-a2d5ceabce22',
        slug: 'blauwbloed-eo',
      },
      '9463c573-b089-43b1-9f15-04aa97088079': {
        baseUrl: 'https://over.eo.nl',
        name: 'Over de EO',
        publicationId: null,
        slug: 'corporate-eo',
      },
      'da5bff01-1d38-4f72-b68d-83202166002e': {
        baseUrl: 'https://dit.eo.nl',
        name: 'DIT',
        publicationId: '0b1ff6f8-ee1a-401f-9bf1-49e8dffcac14',
        slug: 'dit-eo',
      },
      '9beb354c-dde5-4ef9-87c8-5515b09343a7': {
        baseUrl: 'https://ditisdedag.eo.nl',
        name: 'Dit is de dag',
        publicationId: 'b441ffe7-c394-4393-90bd-2e2065d4795e',
        slug: 'ditisdedag-eo',
      },
      '3fc256c0-b074-4780-b401-20e562827537': {
        baseUrl: 'https://www.eo.nl',
        name: 'Eva',
        publicationId: 'ef6cd8a6-9fcd-49e0-85c2-03fdd38a710b',
        slug: 'eva-eo',
      },
      '490d3a0c-6e0f-4d12-bacd-a92625ee8973': {
        baseUrl: null,
        name: 'EO',
        publicationId: null,
        slug: 'generieke-content-eo',
      },
      '94dcecf2-1725-436c-9205-04f20bcffef0': {
        baseUrl: 'https://www.eo.nl',
        name: 'EO',
        publicationId: '78915b89-f177-440a-8f8f-62dfea174d62',
        slug: 'home-eo',
      },
      'd312f523-c7f7-4a46-816b-9d192b376914': {
        baseUrl: 'https://ikmisje.eo.nl',
        name: 'Ik mis je',
        publicationId: '1340eeaa-cb2e-4c7e-9be7-53cd362e3a19',
        slug: 'ikmisje-eo',
      },
      '55177197-688f-4dde-8d1f-509f61babbe7': {
        baseUrl: 'https://www.eo.nl',
        name: 'Lazarus',
        publicationId: '8dbed7fe-74b2-4164-b73d-7bcb19b4cfda',
        slug: 'lazarus-eo',
      },
      '48c62830-e604-48fa-bc4b-693a8962d21e': {
        baseUrl: 'https://www.eo.nl',
        name: 'EO Metterdaad',
        publicationId: '52e68b37-0573-49a5-b7bd-ad6f5c061878',
        slug: 'metterdaad-eo',
      },
      '9a669063-a896-4a1e-bc3a-661f02c3f5b7': {
        baseUrl: 'https://nederlandzingt.eo.nl',
        name: 'Nederland Zingt',
        publicationId: '92728d7c-f683-4c9f-9a43-e1cfcee1bb11',
        slug: 'nederlandzingt-eo',
      },
      'e44f1fbd-1a8b-40d0-9420-4184fed256ee': {
        baseUrl: 'https://stichting.metterdaad.nl',
        name: 'Stichting Metterdaad',
        publicationId: '7a6d27b3-ce37-4828-b919-9a5bd7538c7b',
        slug: 'stichtingmetterdaad-eo',
      },
      'c21bea32-65a1-4b4b-a9d8-5f4544b4ff05': {
        baseUrl: 'https://www.eo.nl',
        name: 'Visie',
        publicationId: '943f11ab-2031-4eda-b77d-0ae968c4518b',
        slug: 'visie-eo',
      },
    },
    models: {
      '9ad0aecf-f7f9-431c-9193-52bc5bc22971': {
        name: 'article',
        plural: 'articles',
      },
      'd297be78-bf58-4270-96a0-b9aec336f952': {
        name: 'campaign',
        plural: 'campaigns',
      },
      '93ee2790-4613-4c08-8603-b2d31c35b682': {
        name: 'community',
        plural: 'communities',
      },
      'cfe72a69-1ab5-450d-9e8f-1fb71618ecd9': {
        name: 'donation',
        plural: 'donations',
      },
      '5abf9393-c127-488a-ac47-72917ec1c701': {
        name: 'event',
        plural: 'events',
      },
      '6b346c1d-0b8f-43dc-8612-655c9828cefa': {
        name: 'form',
        plural: 'forms',
      },
      'eceb6d16-a6e8-439c-88d8-286c97a580ff': {
        name: 'page',
        plural: 'pages',
      },
      '3e97b652-7f9f-4b47-91ef-5f63b448a983': {
        name: 'person',
        plural: 'persons',
      },
      'a45ca4c5-4010-4608-8174-94354e618901': {
        name: 'podcast',
        plural: 'podcasts',
      },
      '4eb98198-f298-48f7-94e9-d0db0fea7d37': {
        name: 'pressrelease',
        plural: 'pressreleases',
      },
      'fa9af868-5af3-49db-8b55-ff1155b2a53b': {
        name: 'program',
        plural: 'programs',
      },
      '77936793-a5f6-4202-9138-ed95d8386a43': {
        name: 'teaser',
        plural: 'teasers',
      },
      '24f80aee-9519-4500-84e5-57553b411696': {
        name: 'topic',
        plural: 'topics',
      },
    },
  },
  baseUrl: {
    npoStart: 'https://www.npostart.nl',
  },
}